module.exports = __webpack_public_path__ + "media/images/img-screenshot-e2b96282e25306bb6fc5e5bf7a5e7f5e.png";